export const getErrorField = (error, field) => {
  return {
    message: error?.[field]?.message,
    show: !!error?.[field]?.message,
  };
};
